import Toastr from "../../../components/Toastr"
const parent = 'SETTING_'
const DEFAULT_STATE = {
  calendar_setting: {}
}
let changes = null;
export default function calendarSettingReducer(state = DEFAULT_STATE, action){
  const response = action.payload && (action.payload.data || action.payload.response)
  let updatedRecord = {};
  switch(action.type){
    case `${parent}CALENDAR_SETTING_LOAD_PENDING`:
      return {...state, saving: false};

    case `${parent}CALENDAR_SETTING_UPDATE_PENDING`:
      return {...state, saving: true};

    case `${parent}CALENDAR_SETTING_LOAD_REJECTED`:
    case `${parent}CALENDAR_SETTING_UPDATE_REJECTED`:
      Toastr.handleShow(response.data.success, response.data.error, response.status_code)
      changes = {
        saving: false
      }
      return {...state,...changes};

    case `${parent}CALENDAR_SETTING_LOAD_FULFILLED`:
      changes = {
        calendar_setting: response.appointment_setting,
        saving: false
      }
      return {...state,...changes};
    
    case `${parent}CALENDAR_SETTING_UPDATE_FULFILLED`:
      Toastr.handleShow(true, response.meta.message, 201)
      updatedRecord = response.appointment_setting;
      changes = {
        calendar_setting: updatedRecord,
        saving: false
      };
      return { ...state, ...changes };

    default:
      return state;
  }
}